export class UpdatePermissionViewModel {
    permissionID: number;
    description: string;
    permissionName: string;
    updatedBy: string;
    updatedOn: string;
    isActive: boolean;
    addPermission: boolean;
    editPermission: boolean;
    deletePermission: boolean;
    moduleId: number;
    organizationID:number=0;
}
